$("body").on("updateAddToCartFormData", function(e, form) {
    $(".engraveInput").each(function(k, item) {
        var id = $(item).attr("id");
        form[id] = $(item).val();
    });
});

function scrollToEngravingFlag() {
    $(".product-colors-images-container").attr("data-scroll-here", "yes");
}

if ($(window).width() < 768) {
    console.log("mobile only");
    scrollToEngravingFlag();
}

function checkEngravingFields() {
    var allEmpty = true;
    $("#modern_engraving_form input").each(function(index) {
        var inputNotEmpty = $(this).val().trim() === "";
        if (!inputNotEmpty) {
            allEmpty = inputNotEmpty;
            return false;
        }
        allEmpty = true;
    });
    return allEmpty;
}

var engravingErrorMessage = $("#engraving-error");

function buildPersonalizationFieldsError() {
    console.log("Personalized Fields are Empty - Adding Error");
    var progressBarElement = $("#maf-progress-bar");
    var engravingForm = $("#modern_engraving_form");
    var headerHeight = $("#maf-global-navbar")[0].offsetHeight;

    engravingForm.addClass("is-invalid");

    $("html, body").animate(
        {
            scrollTop: progressBarElement.offset().top + headerHeight
        },
        300
    );

    engravingErrorMessage.removeClass("d-none");
}

function removePersonalizationFieldsError() {
    console.log("Personalized Fields are NOT Empty - Removing Error");
    $("#modern_engraving_form").removeClass("is-invalid");
    engravingErrorMessage.addClass("d-none");
}

function buildConfirmationBoxError() {
    var boxConfirmationError = $(".custom-engrave-container .declaration");
    boxConfirmationError.addClass("is-invalid");
}

function removeConfirmationBoxError() {
    var boxConfirmationError = $(".custom-engrave-container .declaration");
    boxConfirmationError.removeClass("is-invalid");
}

function checkConfirmationBox() {
    var boxChecked = false;
    var emptyFields = checkEngravingFields();
    var confirmationBoxCheck = $("#EngraveCheckboxPDP").prop("checked");

    if (confirmationBoxCheck) {
        boxChecked = true;
        removeConfirmationBoxError();
        if (!emptyFields) {
            console.log("we can move to plans");
        }
    } else {
        boxChecked = false;
        buildConfirmationBoxError();
    }
    return boxChecked;
}

$("#customizeEngraveid").click(function() {
    var emptyFields = checkEngravingFields();
    var confirmationChecked = checkConfirmationBox();
    console.log("confirmationChecked", confirmationChecked);
    if (emptyFields) {
        buildPersonalizationFieldsError();
    } else {
        removePersonalizationFieldsError();
    }
});

$("body").on("input", "#modern_engraving_form input", function(e) {
    var emptyFields = checkEngravingFields();
    enableButtonAddToCart();
    if (emptyFields) {
        return;
    } else {
        removePersonalizationFieldsError();
    
    }
});

function enableButtonAddToCart() {
    var emptyFields = checkEngravingFields();
    var confirmationChecked = $("#EngraveCheckboxPDP").prop("checked");

    if (!emptyFields && confirmationChecked) {
        $("#selectPlanNextStep input").addClass("move-to-plan");
    } else {
        $("#selectPlanNextStep input").removeClass("move-to-plan");
    }
}

$("#EngraveCheckboxPDP").on("change", function() {
    var confirmationChecked = $("#EngraveCheckboxPDP").prop("checked");
    if (confirmationChecked) {
        removeConfirmationBoxError();
    }
    enableButtonAddToCart();
});

$("body").on("click", "#customizeid", function(e) {
    console.log("#customizeid");
    // Target the element you want to scroll to
    var targetElement = $(
        '.product-colors-images-container[data-scroll-here="yes"]'
    );


    if(targetElement.length === 0) {
        return;
    }
    // Scroll to the element smoothly
    $("html, body").animate(
        {
            scrollTop: targetElement?.offset().top
        },
        30
    ); // Adjust the duration (in milliseconds) as needed
});

$('.engraveInput').on('change', function() {
    let value = $(this).val();    
    // This fixes the specific behavior on mac of the automatic period insertion.
    // Replace ".  " (period followed by two spaces) with ". " (period followed by one space)
    value = value.replace(/\. {2}/g, ' '); 
    $(this).val(value);
});